import { ReactNode } from "react"
import { MantineProvider, MantineThemeOverride, mergeMantineTheme } from "@mantine/core"
import theme from "@/entities/theme/config/style.config"
import { selectButtonColor, selectGraphColor } from "@/entities/options"
import { useAppSelector } from "@/shared/lib/store"

interface ThemeProviderProps {
	children: ReactNode
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
	const buttonColor = useAppSelector(selectButtonColor)
	const graphColor = useAppSelector(selectGraphColor)

	const themeOverride: MantineThemeOverride = {
		colors: {
			custom: [buttonColor || "", graphColor || "", "", "", "", "", "", "", "", ""],
		},
	}

	const themeResult = mergeMantineTheme(theme, themeOverride)

	return <MantineProvider theme={themeResult}>{children}</MantineProvider>
}
